import * as React from 'react';

const blogIconSmall = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23111_907)">
      <path
        d="M16.4935 1H3.502C2.43262 1 1.5625 1.86998 1.5625 2.9395V17.0605C1.5625 18.13 2.43262 19 3.502 19H16.4933C17.5629 19 18.4328 18.13 18.4328 17.0605V2.9395C18.4328 1.86998 17.5629 1 16.4935 1Z"
        fill="url(#paint0_linear_23111_907)"
      />
      <path
        d="M16.4934 1H11.6921V19H16.4933C17.5628 19 18.4328 18.13 18.4328 17.0605V2.9395C18.4328 1.86998 17.5628 1 16.4934 1Z"
        fill="url(#paint1_linear_23111_907)"
      />
      <path
        d="M5.479 19C5.18773 19 4.95166 18.7639 4.95166 18.4727V1.52734C4.95166 1.23607 5.18773 1 5.479 1C5.77014 1 6.00635 1.23607 6.00635 1.52734V18.4727C6.00635 18.7639 5.77014 19 5.479 19Z"
        fill="url(#paint2_linear_23111_907)"
      />
      <path
        d="M13.8952 11.2599C13.7249 11.1336 13.712 10.8682 13.8665 10.7229C14.4821 10.1434 14.8672 9.32161 14.8672 8.41138C14.8672 6.66071 13.4428 5.23633 11.6921 5.23633C9.94147 5.23633 8.51709 6.66071 8.51709 8.41138C8.51709 9.3216 8.90214 10.1434 9.5178 10.7228C9.67222 10.8682 9.65931 11.1336 9.48903 11.2599C8.57858 11.9355 7.98755 13.0181 7.98755 14.2363C7.98755 14.5276 8.22362 14.7637 8.51489 14.7637H14.8694C15.1605 14.7637 15.3967 14.5276 15.3967 14.2363C15.3967 13.0181 14.8056 11.9355 13.8952 11.2599Z"
        fill="url(#paint3_linear_23111_907)"
      />
      <path
        d="M13.8952 11.2599C13.7249 11.1336 13.712 10.8682 13.8665 10.7229C14.4821 10.1434 14.8672 9.32161 14.8672 8.41138C14.8672 6.75796 13.5967 5.39559 11.9807 5.24933C11.8219 5.23495 11.6921 5.36561 11.6921 5.5251V14.4749C11.6921 14.6344 11.8214 14.7637 11.9809 14.7637H14.8694C15.1605 14.7637 15.3967 14.5276 15.3967 14.2363C15.3967 13.0181 14.8056 11.9355 13.8952 11.2599Z"
        fill="url(#paint4_linear_23111_907)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_23111_907"
        x1="15.7773"
        y1="16.0883"
        x2="-5.41298"
        y2="8.73351"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_23111_907"
        x1="6"
        y1="16"
        x2="-0.471211"
        y2="9.83277"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_23111_907"
        x1="5.72717"
        y1="14.2857"
        x2="5.02673"
        y2="14.2748"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_23111_907"
        x1="24.5"
        y1="12.5"
        x2="15.4865"
        y2="16.8037"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_23111_907"
        x1="14.4161"
        y1="12.2684"
        x2="11.9811"
        y2="12.0174"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_23111_907">
        <rect width="18" height="18" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

export default blogIconSmall; 
